export default __webpack_public_path__ + "static/media/paysgLogo.e3b75815.svg";